import { graphQLClient } from 'src/services/shared/GraphQLService';
import { gql } from 'graphql-request';

const startConsumerMutation = gql`  mutation StartConsumer(
    $client_id: uuid!,
    $req: StartConsumerRequest!
  ) {
    start_consumer(client_id: $client_id, req: $req) {
      id
    }
  }
`;

export const startConsumer = async ({
                                        client_id,
                                        req,
                                        hasuraAccessToken,
                                    }: {
    client_id: string;
    req: { saas: string; connection_id: string };
    hasuraAccessToken: string;
}) => {
    if (!client_id) throw new Error('client_id required');
    if (!req?.saas) throw new Error('saas required in req');
    if (!req?.connection_id) throw new Error('connection_id required in req');

    const client = await graphQLClient({ accessToken: hasuraAccessToken });

    const variables = { client_id, req };

    const result = await client?.request(startConsumerMutation, variables);

    if (result?.error) throw new Error(result.error.message);

    return result;
};
